import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { UIRouter } from '@uirouter/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject, fromEvent, takeUntil } from 'rxjs';
import { AppFlavour } from '@core/models/config/app-flavour';
import { RouterService } from '@core/state/router/router.service';
import { WindowRef } from '@vendor/window/window.component';
import { DirectivesModule } from '@shared/directives/directives.module';
import { CommonModule } from '@angular/common';
import { AppFlavourClassDirective } from '@shared/directives/app/app-flavour-class.directive';

@Component({
    selector: 'pay-mobile-blocker',
    templateUrl: 'mobile-blocker.component.html',
    styleUrls: ['./mobile-blocker.component.scss'],
    imports: [CommonModule, TranslateModule, DirectivesModule, AppFlavourClassDirective],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'c-mobile-blocker',
    },
})
export class MobileBlockerComponent implements OnInit, OnDestroy {
    /**
     * By default the blocker component is used at the app level and kicks in for smaller screen sizes
     * But the blocker component can also be used as a view to be displayed on smaller sizes - like inside registration
     * In such a case do not let the modal blocker kick in
     */
    @Input()
    asUIView: boolean = false;

    @Input()
    title: string = 'Default.Mobile.Blocker.Title';

    @Input()
    subtitle: string = '';

    @Input()
    description: string = '';

    @Input()
    descriptionMore: string = 'Default.Mobile.Blocker.FromComputer';

    public readonly APP_FLAVOUR: typeof AppFlavour = AppFlavour;
    public showBlocker: boolean = false;

    private readonly MINIMUM_SCREEN_WIDTH = 768;
    private readonly MINIMUM_SCREEN_HEIGHT = 600;
    private destroyed$: Subject<void> = new Subject();

    constructor(
        private router: UIRouter,
        private appRouterService: RouterService,
        private translateService: TranslateService,
        private windowRef: WindowRef,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit() {

        
        
        this.checkScreen();
        this.cdr.markForCheck();


        fromEvent(this.windowRef.nativeWindow, 'resize')
            .pipe(takeUntil(this.destroyed$))
            .subscribe((event) => {
                this.checkScreen();
                this.cdr.markForCheck();
            });

    }

    ngOnDestroy() {
        this.destroyed$.next();
    }

    private checkScreen() {
        this.showBlocker = !!screen?.orientation && (screen?.width < this.MINIMUM_SCREEN_WIDTH || screen?.height < this.MINIMUM_SCREEN_HEIGHT);
    }
}
